import { Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

/** Gets `entityId` from url. */
@Injectable()
export class TabBase {
  /** Holds entityId coming from url (legacy observable API). */
  entityId$ = new BehaviorSubject('');

  /** Holds entityId coming from url (signal API). */
  protected entityId = signal<string | null>(null);

  constructor(
    /** Pass the `ActivatedRoute` having params holding the `entityId` we want to grab from the url */
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private route: ActivatedRoute
  ) {
    // Gets entityId from url and updates both APIs
    this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
      const entityId = Object.values(params || {})[0] as string | undefined;

      if (!entityId) {
        return;
      }

      this.entityId$.next(entityId);
      this.entityId.set(entityId);
    });
  }
}
